// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sPIwF","left":"styles_left__3DNb6"};